import { render } from "./ProductModelAutoBom.vue?vue&type=template&id=134d2a0a&scoped=true"
import script from "./ProductModelAutoBom.vue?vue&type=script&lang=js"
export * from "./ProductModelAutoBom.vue?vue&type=script&lang=js"

import "./ProductModelAutoBom.vue?vue&type=style&index=0&id=134d2a0a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134d2a0a"]])

export default __exports__